import React, { useCallback } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import cx from 'clsx'
import { IconSquareRoundedPlus } from '@tabler/icons-react'

import Button from '@src/components/Button'

import routes from '@src/Routes/routes'

import styles from '../index.module.css'

const TabNavigation = () => {
  const { t } = useTranslation('reports', { keyPrefix: 'list' })
  const navigate = useNavigate()
  const handleCreateReport = useCallback(() => navigate(routes.private.createReport), [])

  return (
    <div className="justify-between flex flex-wrap gap-2">
      <span className="flex text-xl">
        <NavLink
          className={({ isActive }) => {
            return cx(styles.tab, { [styles.active]: isActive })
          }}
          end
          to={routes.private.reports}
        >
          {t('tabs.manual')}
        </NavLink>
      </span>
      <Button
        color="primary"
        className="text-base font-medium mb-2 gap-1 w-full xs:w-auto"
        onClick={handleCreateReport}
      >
        <IconSquareRoundedPlus size={20} />
        {t('newReport')}
      </Button>
    </div>
  )
}

export default TabNavigation
